import { makeChartComp } from '../../util/makeChartComp';
var BarChart = makeChartComp('Bar');
export default BarChart;
